import { downloadImage } from "@/utils/Image";
import CompassRose from "./compass_rose.svg";

export const COMPASS_ROSE_SIZE = { width: 128, height: 128 };

export class MapCompassRoseCreator {
  /**
   *
   * @param {String} [url]
   * @param {Object} [options]
   * @param {String} [options.type='image'] 'image', 'dataurl' or 'blob'
   */
  static async create(url, options = {}) {
    const compassRoseImage = await downloadImage(url || CompassRose, {
      type: options.type || "image"
    });

    return compassRoseImage;
  }
}
